<app-subject-form
  [currentAddressFormGroup]="addressFormGroup"
  [enableEmployment]="true" [enableIdentificationHeader]="true" [enablePreviousAddress]="true"
  [identificationFormGroup]="identificationFormGroup" [prevAddressFormGroup]="prevAddressFormGroup" [subjectFormGroup]="subjectFormGroup"
  [additionalFormContentFormGroup]="idxFormGroup" additionalFormControlName="idx"
  (back)="back.emit()" (submittedData)="submittedData.emit($event)" (formSubmitted)="displayErrors = $event"
  >
  <div [formGroup]="identificationFormGroup" [ngClass]="{'ng-invalid-group': identificationFormGroup.errors}">
    <div class="mb-2">{{ 'content.enter-one-sin-dob-account' | translate }}</div>
    <div class="row">
      <div class="form-group col-md-3">
        <!-- TODO: (feature) date picker -->
        <label>{{ 'content.person.dob' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="dob" mask="0000-00-00" placeholder="yyyy-mm-dd" #dobInput>
        </label>
        <!-- TODO: (feature) validate it's a real date -->
        <app-validation-errors [displayErrors]="displayErrors"
          [errors]="[identificationFormGroup.errors, identificationFormGroup.controls.dob.errors]"
        [element]="dobInput"></app-validation-errors>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label>{{ 'content.social-insurance-number-short' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="sin" mask="000-000-000" placeholder="" #sinInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors"
          [errors]="[identificationFormGroup.errors, identificationFormGroup.controls.sin.errors]"
        [element]="sinInput"></app-validation-errors>
      </div>
    </div>
    <div class="row" [formGroup]="card1F">
      <div class="form-group col-md-4 pe-2">
        <label>{{ 'content.card1' | translate }}
          <select class="form-select" formControlName="type" #typeInput>
            @for (cardType of cardTypes; track cardType) {
              <option value="{{ cardType }}">{{ cardType }}</option>
            }
          </select>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="card1F.controls.type.errors" [element]="typeInput"></app-validation-errors>
      </div>
      <div class="form-group col-md-8">
        <label>{{ 'content.account-num' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="num" #numInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors"
          [errors]="[identificationFormGroup.errors, card1F.controls.num.errors]"
        [element]="numInput"></app-validation-errors>
      </div>
    </div>
    <div class="row" [formGroup]="card2F">
      <div class="form-group col-md-4 pe-2">
        <label>{{ 'content.card2' | translate }}
          <select class="form-select" autocomplete="on" formControlName="type" #typeInput2>
            @for (cardType of cardTypes; track cardType) {
              <option value="{{ cardType }}">{{ cardType }}</option>
            }
          </select>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="card2F.controls.type.errors" [element]="typeInput2"></app-validation-errors>
      </div>
      <div class="form-group col-md-8">
        <label>{{ 'content.account-num' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="num" #numInput2>
        </label>
        <app-validation-errors [displayErrors]="displayErrors"
          [errors]="[identificationFormGroup.errors, card2F.controls.num.errors]"
        [element]="numInput2"></app-validation-errors>
      </div>
    </div>
  </div>
  @if (isIdx) {
    <ng-template #additionalFormContent>
      <h3>{{ 'content.idx' | translate }}</h3>
      <div [formGroup]="idxFormGroup" [ngClass]="{'ng-invalid-group': idxFormGroup.errors}">
        <div class="row">
          <div class="form-group col-md-4 pe-2">
            <label>{{ 'content.client-id' | translate }} *
              <input class="form-control" type="text" autocomplete="on" formControlName="clientId" #clientIdInput>
            </label>
            <app-validation-errors [displayErrors]="displayErrors" [errors]="idxFormGroup.controls.clientId.errors" [element]="clientIdInput"></app-validation-errors>
          </div>
          <div class="form-group col-md-4 pe-2">
            <label>{{ 'content.person.email' | translate }} *
              <input class="form-control" type="email" autocomplete="on" formControlName="emailAddress" placeholder="email@example.com" #emailInput>
            </label>
            <app-validation-errors [displayErrors]="displayErrors" [errors]="idxFormGroup.controls.emailAddress.errors" [element]="emailInput"></app-validation-errors>
          </div>
          <div class="form-group col-md-4 pe-2">
            <label class="d-block">{{ 'content.ip' | translate }} *
              <input #ipInput class="form-control" type="text" autocomplete="on" formControlName="ipAddress"
                mask="IP" placeholder="111.111.111.111" [dropSpecialCharacters]="false" [validation]="false">
              </label>
              <app-validation-errors [displayErrors]="displayErrors" [element]="ipInput" [errors]="idxFormGroup.controls.ipAddress.errors"></app-validation-errors>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-3 col-md-4 col-12 pe-2">
              <label>{{ 'content.product-type' | translate }} *
                <select class="form-select" autocomplete="on" formControlName="productType" #productTypeInput>
                  @for (prodType of idxProductTypes | keyvalue; track prodType) {
                    <option value="{{ prodType.key }}">{{ prodType.value }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="displayErrors" [errors]="idxFormGroup.controls.productType.errors" [element]="productTypeInput"></app-validation-errors>
            </div>
            <div class="form-group col-lg-3 col-md-4 col-12 pe-2">
              <label>{{ 'content.interaction-type' | translate }} *
                <select class="form-select" autocomplete="on" formControlName="interactionType" #interactionTypeInput>
                  @for (interactionType of idxInteractionTypes | keyvalue; track interactionType) {
                    <option value="{{ interactionType.key }}">{{ interactionType.value }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="displayErrors" [errors]="idxFormGroup.controls.interactionType.errors" [element]="interactionTypeInput"></app-validation-errors>
            </div>
            <div class="form-group col-lg-3 col-md-4 col-12 pe-2">
              <label>{{ 'content.application-channel' | translate }} *
                <select class="form-select" autocomplete="on" formControlName="applicationChannel" #applicationChannelInput>
                  @for (appChannel of idxApplicationChannels | keyvalue; track appChannel) {
                    <option value="{{ appChannel.key }}">{{ appChannel.value }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="displayErrors" [errors]="idxFormGroup.controls.applicationChannel.errors" [element]="applicationChannelInput"></app-validation-errors>
            </div>
          </div>
        </div>
      </ng-template>
    }
  </app-subject-form>
